import { useEffect, useState } from 'react';

import { authorizeZoomApp } from '../../db/online-meeting/actions';
import { selectZoomAuthorizationData } from '../../db/online-meeting/selectors';
import { useAppSelector } from '../../store/hooks';
import { useRequestDispatch } from '../../utils/request-actions';

export interface Props {
  open: boolean;
  onClose: () => void;
}

const useZoomIntegrationDialogVM = ({ open, onClose }: Props) => {
  const requestDispatch = useRequestDispatch();

  const zoomAuthorizationData = useAppSelector((state) => selectZoomAuthorizationData(state));

  const [isAuthorizing, setIsAuthorizing] = useState(false);

  useEffect(
    function initializeZoomAuthorization() {
      if (!open) return;

      setIsAuthorizing(true);
      requestDispatch(authorizeZoomApp).finally(() => setIsAuthorizing(false));
    },
    [open, requestDispatch]
  );

  return { isAuthorizing, zoomAuthorizationData };
};

export default useZoomIntegrationDialogVM;
